import { useQuery } from "@apollo/client/react";
import { CurrentUserDocument } from "@/generated/graphql";

export { CURRENT_USER_QUERY } from "@/graphql/auth";

export function useCurrentUser() {
  const { data, loading, error, refetch } = useQuery(CurrentUserDocument, {
    fetchPolicy: "network-only",
  });

  const user = data?.currentUser ?? null;

  return {
    user,
    loading,
    error,
    refetch,
    isAuthenticated: !!user,
  };
}
